/**
 * @file serviceWorker.js
 * @description Single service worker script for the app. pwa-sw.js imports
 * firebase-messaging-sw.js, and every registration must use the same script so the
 * worker on scope "/" is never swapped while the app is open.
 */

export const SERVICE_WORKER_URL = '/pwa-sw.js';
export const SERVICE_WORKER_SCOPE = '/';
